import { Field } from "@qid/field";
import { ParticipantRoles } from "../enum/participant-roles.enum";
import { AccountType } from "@qid/core";
import { User } from "../../user";
import { Organisation } from "../../organisation";
import { Signature } from "../../signature";
import { IdField } from "../../id";
import { DocumentAccess } from "../../document-access";
import { ID } from "../../../models/ID";
import { ShareStatus } from "../enum/share-status.enum";

export class Participant {

  account_id: string;
  accountType: AccountType;
  /** @deprecated Use `accountSnapshot` instead for immutable/account state at share time. */
  account: User | Organisation | any;
  accountSnapshot: User | Organisation | any;
  memberId: string;
  sharedDocumentsIds: string[];
  signature: Signature;
  signatureImageUrl: string;
  otherFields: Field[];
  roles: ParticipantRoles[];

  name: string;
  email: string;
  phoneNumber?: string;

  mandatoryIds: Field<IdField>[] = [];
  optionalIds: Field<IdField>[] = [];
  documentsAccess: DocumentAccess[] = [];

  identityDocument: ID

  facePhoto: {
    isLive: boolean;
    imageUrl: string;
  }

  profile: SharedProfile

  analytics: any;

  parentAccount_id: string;

  participantShareStatus: ShareStatus

  constructor() {

  }
}

export class SharedProfile {
  attributes: { label: string, value: any }[]
  isVerified: boolean;
  verificationMethod: string;
}
